// extracted by mini-css-extract-plugin
module.exports = {"subtitlesLogo":"_2JHKWD"};